import React from "react";
import { Form, Select, Modal } from "antd";
import { bindActionCreators } from "redux";
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import api from "../../api/api";
import { defaultFormValues } from "../../api/requiredFunctions";
import { saveCashRequestDto } from "../../redux-stuffs/actions/profile_action";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { merchantAddressState, merchantNameState, amountState, accessTokenState } from '../../atoms';
import withRecoil from '../../withRecoil';
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import "./styles/AmountAvailable.css";
import { GOOGLE_MAPS_API_KEY } from "../../config/google";

var _ = require('lodash');

const MIN_ESCROW_AMOUNT = 5;
const LOCATION_DEBOUNCE_MS = 1500;
const { Option } = Select;

function error(title, content) {
  Modal.error({
    title: title,
    content: content,
  });
}

class AddressInputInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      suggestions: [],
      zipcode: '',
      isEditing: true,
      locationLoading: false,
      locationFound: false,
      lat: null,
      long: null,
      requested_amount: null,
      amountError: null,
      confirmedAddress: "",
      uuid: null,
      escrow_amount: null,
    };
    this.locationChangeTimeout = null;
    this.locationChangeQueued = null;
    this.dashboardMapUpdateTimeout = null;
  }

  handleAmountChange = (e) => {
    const { t } = this.props;
    let value = e.target.value;

    if (!/^\d*$/.test(value)) {
      this.setState({
        requested_amount: null,
        amountError: t('amountError_invalidChars', { ns: 'amountAvailable' }),
        fee: 0
      }, () => {
        this.cancelQueuedDashboardMapUpdate();
        this.resetDashboardMapQuery();
      });
      return;
    }

    value = value.replace(/[^\d]/g, '');
    let numericValue = parseInt(value, 10);
    const escrow_amount = this.state.escrow_amount || 0;

    if (escrow_amount < MIN_ESCROW_AMOUNT) {
      this.setState({
        requested_amount: null,
        amountError: t('amountError_minBalance', { ns: 'amountAvailable', min: MIN_ESCROW_AMOUNT }),
        fee: 0
      }, () => {
        this.cancelQueuedDashboardMapUpdate();
        this.resetDashboardMapQuery();
      });
    }
    else if (!numericValue || numericValue < MIN_ESCROW_AMOUNT || numericValue > escrow_amount || numericValue > 1499) {
      this.setState({
        requested_amount: null,
        amountError: t('amountError_rangeFixedMax', { ns: 'amountAvailable', min: MIN_ESCROW_AMOUNT }),
        fee: 0
      }, () => {
        this.cancelQueuedDashboardMapUpdate();
        this.resetDashboardMapQuery();
      });
    }
    else {
      this.setState({
        requested_amount: numericValue,
        amountError: ""
      }, () => {
        this.queueDashboardBusinessesUpdate({ debounce: false });
        this.announceSearchPending({ requestedAmountOverride: numericValue, reason: 'amount' });
      });
    }
  };

  componentDidMount() {
    this.hasActiveCashRequest();
    this.updateEscrow();
    this.prefillRegisteredAddress();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.amountPromptKey !== this.props.amountPromptKey &&
      this.props.amountPromptKey &&
      !this.state.requested_amount
    ) {
      this.setState({
        amountError: this.props.t('enterAmountFirst', { ns: 'amountAvailable' }),
      });
    }
  }

  componentWillUnmount() {
    this.cancelScheduledLocationChange();
    this.cancelQueuedDashboardMapUpdate();
  }

  cancelScheduledLocationChange = () => {
    if (this.locationChangeTimeout) {
      clearTimeout(this.locationChangeTimeout);
      this.locationChangeTimeout = null;
    }
    this.locationChangeQueued = null;
  }

  scheduleLocationChange = ({ lat, lng, address }, { debounce = true } = {}) => {
    const resolvedAddress = address || this.state.address;
    if (typeof lat !== 'number' || typeof lng !== 'number' || !resolvedAddress) {
      return;
    }

    const notifyParent = (payload) => {
      if (typeof this.props.onLocationChange === 'function') {
        this.props.onLocationChange(payload);
      }
    };

    notifyParent({ lat, lng, address: resolvedAddress });
    this.queueDashboardBusinessesUpdate({ debounce });
    this.announceSearchPending({ reason: 'location' });
  }

  resetDashboardMapQuery = () => {
    this.lastDashboardMapQuery = null;
  }

  cancelQueuedDashboardMapUpdate = () => {
    if (this.dashboardMapUpdateTimeout) {
      clearTimeout(this.dashboardMapUpdateTimeout);
      this.dashboardMapUpdateTimeout = null;
    }
  }

  queueDashboardBusinessesUpdate = ({ debounce = true } = {}) => {
    if (typeof this.props.onBusinessesLoaded !== 'function') {
      return;
    }

    this.cancelQueuedDashboardMapUpdate();

    const runUpdate = () => {
      this.dashboardMapUpdateTimeout = null;
      this.maybeUpdateDashboardMap();
    };

    if (!debounce) {
      runUpdate();
      return;
    }

    this.dashboardMapUpdateTimeout = setTimeout(runUpdate, LOCATION_DEBOUNCE_MS);
  }

  handleSelect = async (address) => {
    this.processSelectedAddress(address, { debounce: true });
  }

  processSelectedAddress = async (address, { debounce = true } = {}) => {
    this.setState({ address, confirmedAddress: address });
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({ lat: lat, long: lng }, () => {
          this.scheduleLocationChange({ lat, lng, address }, { debounce });
        });
        const apiKey = GOOGLE_MAPS_API_KEY;
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Status: ${response.status}`)
            }
            return response.json();
          })
          .then((data) => {
            const firstRes = data.results[0]
            const zipcode = firstRes?.address_components.find(
              (component) => component.types.includes("postal_code")
            )?.short_name;
            if (zipcode) {
              this.setState({ zipcode: zipcode, isEditing: false }, () => {
                this.props.form.setFieldsValue({
                  zip: zipcode,
                });
                this.queueDashboardBusinessesUpdate({ debounce });
              });
            }
            else {
              console.error("No valid zipcode")
            }
          })
          .catch((error) => {
            console.error("Error fetching location details: ", error.message);
          })
      })
      .catch((error) => {
        console.error("Error: There are no available merchants in your selected area.");
      });
  }

  handleAddressBlur = () => {
    const { t } = this.props;
    const { address, confirmedAddress } = this.state;

    if (!confirmedAddress || address !== confirmedAddress) {
      this.setState({
        address: '',
        confirmedAddress: '',
        zipcode: '',
        isEditing: true,
        addressError: t('addressError_selectValid', { ns: 'amountAvailable' }),
        suggestions: []
      });
      this.cancelScheduledLocationChange();
      this.cancelQueuedDashboardMapUpdate();
      this.resetDashboardMapQuery();

      this.props.form.setFieldsValue({ address: '' });
    }

    if ((confirmedAddress || address === confirmedAddress) && !this.state.isEditing) {
      this.setState({
        addressError: null
      });
      this.props.form.setFieldsValue({ address: address });
    }
  };

  handleSearch = (value) => {
    const autocompleter = new window.google.maps.places.AutocompleteService();
    autocompleter.getPlacePredictions(
      {
        input: value,
        types: ['geocode'],
      },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const results = predictions.slice(0, 20);
          this.setState({ suggestions: results })
        }
      }
    )
  }

  handleFormSubmit = (e) => {
    const { t } = this.props;
    e.preventDefault();
    const { requested_amount, escrow_amount } = this.state;

    if (!requested_amount || requested_amount < MIN_ESCROW_AMOUNT || requested_amount > escrow_amount || requested_amount > 1499) {
      this.setState({
        amountError: t('amountError_rangeDynamic', { ns: 'amountAvailable', min: MIN_ESCROW_AMOUNT, max: escrow_amount })
      });
      return;
    }

    this.props.form.validateFields((err) => {
      if (!err) {
        const finalBody = this.buildShowAgentBody();
        if (!finalBody) {
          return;
        }
        this.fetchNearbyBusinesses(finalBody);
      }
    });
  };

  hasActiveCashRequest() {
    let body = {
      access_token: this.props.token,
      device_type: 5,
      device_token: 1,
      app_version: 1
    }
    fetch(`${api.main}/access_token_login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: queryString.stringify(body),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        if (res.status !== 105) {
          error("Error", res.message);
        } else {
          this.setState({ uuid: res.data.uuid });
          let body2 = {
            access_token: this.props.recoilStates.accessTokenState.state,
            request_type: 1
          };

          fetch(`${api.main}/cash_request_history`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: queryString.stringify(body2)
          })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            })
            .then(res => {
              if (res.status === 105 && res.data.length >= 1) {
                const selectedLocation = res.data[0];
                this.props.recoilStates.merchantAddressState.setState(selectedLocation.address)
                this.props.recoilStates.merchantNameState.setState(selectedLocation.name)
                this.props.recoilStates.amountState.setState(selectedLocation.amount)
                this.props.saveCashRequestDto(selectedLocation)

                const { t } = this.props;

                Modal.confirm({
                  className: "confirm-modal",
                  title: t('existingPickup_title', { ns: 'amountAvailable' }),
                  content: (
                    <div className="amount-available__modal-content">
                      {t('existingPickup_content', { ns: 'amountAvailable' })}
                    </div>
                  ),
                  keyboard: false,
                  maskClosable: false,
                  okCancel: false,
                  okText: t('existingPickup_ok', { ns: 'amountAvailable' }),
                  okButtonProps: {
                    className: "action-button-compact btn confirm-ok",
                    type: "default",
                    size: "small",
                  },
                  onOk: () =>
                    this.props.history.push({
                      pathname: "/dashboard/pickup",
                      state: {
                        zipcode: selectedLocation.zipcode,
                        fee: selectedLocation.charges,
                        uuid: this.state.uuid,
                      },
                    }),
                });
              }
            })
            .catch(err => {
              this.props.history.push({
                pathname: '/dashboard'
              })
            })
          const escrow_amount = _.get(res, 'data.escrow_amount');
          this.setState({
            escrow_amount
          });
          this.props.profile.escrow_amount = res.data.escrow_amount;
        }
      })
      .catch(err => {
        this.props.history.push({
          pathname: '/dashboard'
        })
      })
  }

  locateZip = async () => {
    if ("geolocation" in navigator) {
      this.setState({ locationLoading: true })
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          this.setState({ lat: latitude, long: longitude })
          const apiKey = GOOGLE_MAPS_API_KEY;
          const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
          fetch(apiUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Status: ${response.status}`)
              }
              return response.json();
            })
            .then((data) => {
              const firstRes = data.results[0]
              const zipcode = firstRes?.address_components.find(
                (component) => component.types.includes("postal_code")
              )?.short_name;
              if (zipcode) {
                this.setState({ zipcode: zipcode, isEditing: false, address: zipcode, confirmedAddress: zipcode }, () => {
                  this.props.form.setFieldsValue({
                    address: zipcode,
                    zip: zipcode,
                  })
                  this.queueDashboardBusinessesUpdate({ debounce: true });
                })
                this.scheduleLocationChange({ lat: latitude, lng: longitude, address: zipcode });
                this.setState({ locationFound: true })
                this.setState({ locationLoading: false })
                setTimeout(() => {
                  this.setState({ locationFound: false });
                }, 3000);
              }
              else {
                console.error("No valid zipcode")
                this.setState({ locationLoading: false })
              }
            })
            .catch((error) => {
              console.error("Error fetching location details: ", error.message);
              this.setState({ locationLoading: false })
            });
        },
        (error) => {
          console.error("Error getting location: " + error.message);
          this.setState({ locationLoading: false })
        }
      );
    }
    else {
      this.setState({ locationLoading: false })
    }
  }

  updateEscrow() {
    let body = {
      access_token: this.props.token,
      device_type: 5,
      device_token: 1,
      app_version: 1
    }
    fetch(`${api.main}/access_token_login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: queryString.stringify(body),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        if (res.status !== 105) {
          error("Error", res.message);
        } else {
          const escrow_amount = _.get(res, 'data.escrow_amount');
          this.setState({
            escrow_amount
          });
          this.props.profile.escrow_amount = res.data.escrow_amount;
        }
      })
      .catch(err => {
        this.props.history.push({
          pathname: 'login'
        })
      })
  }

  isFormValid = () => {
    const { requested_amount, confirmedAddress } = this.state;
    return requested_amount && confirmedAddress;
  }

  prefillRegisteredAddress = () => {
    const { token } = this.props;
    if (!token || this.state.address) {
      return;
    }

    const headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
    const body = queryString.stringify({ access_token: token });

    fetch(`${api.extra}/api/get_user_information`, {
      method: 'POST',
      headers,
      body,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const user = data && data.user ? data.user : {};
        const addressParts = [
          user.address,
          user.city,
          user.state,
          user.zipcode,
          user.country,
        ].filter(Boolean);

        if (!addressParts.length) {
          return;
        }

        const formattedAddress = addressParts.join(', ');
        this.processSelectedAddress(formattedAddress, { debounce: false });
      })
      .catch(err => {
        console.error('Error pre-filling registered address:', err.message || err);
      });
  };

  buildShowAgentBody = ({ allowFallbackAmount = false } = {}) => {
    const { requested_amount, confirmedAddress, zipcode, lat, long } = this.state;
    const accessToken = this.props.recoilStates?.accessTokenState?.state;
    const amount = requested_amount || (allowFallbackAmount ? MIN_ESCROW_AMOUNT : null);
    if (!amount || !confirmedAddress || !zipcode || typeof lat !== 'number' || typeof long !== 'number' || !accessToken) {
      return null;
    }

    return {
      ...defaultFormValues(),
      zip: zipcode,
      amount,
      access_token: accessToken,
    };
  };

  fetchNearbyBusinesses = (finalBody, { updateDashboardOnly = false } = {}) => {
    const { t } = this.props;
    return fetch(`${api.main}/show_agent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: queryString.stringify(finalBody),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        if (res.status !== 105) {
          this.notifyBusinessesLoaded([], { noResults: true, isSearching: false });
          if (!updateDashboardOnly) {
            error("Error", res.message);
          }
          return null;
        }

        const processedBusinesses = res.data.map(business => ({
          ...business,
          surcharge: business.surcharge || res.surcharge || 0,
          surcharge_type: business.surcharge_type || 'Default'
        }));

        this.notifyBusinessesLoaded(processedBusinesses, { isSearching: false });

        if (!updateDashboardOnly) {
          this.props.history.push({
            pathname: '/dashboard/amount-available',
            state: {
              businesses: processedBusinesses,
              requested_amount: this.state.requested_amount,
              address: this.state.address,
              zipcode: this.state.zipcode,
              lat: this.state.lat,
              long: this.state.long,
              uuid: this.state.uuid,
            }
          });
        }

        return processedBusinesses;
      })
      .catch(err => {
        if (updateDashboardOnly) {
          console.error('Error fetching nearby businesses:', err.message || err);
          this.notifyBusinessesLoaded([], { noResults: true, isSearching: false });
        } else {
          error(t('errorTitle', { ns: 'amountAvailable' }), t('internalServerError', { ns: 'amountAvailable' }));
        }
        return null;
      });
  };

  notifyBusinessesLoaded = (businesses, extra = {}) => {
    if (typeof this.props.onBusinessesLoaded !== 'function') {
      return;
    }

    this.props.onBusinessesLoaded(Array.isArray(businesses) ? businesses : [], {
      lat: this.state.lat,
      lng: this.state.long,
      address: this.state.address,
      zipcode: this.state.zipcode,
      requested_amount: this.state.requested_amount,
      uuid: this.state.uuid,
      ...extra,
    });
  }

  announceSearchPending = ({ requestedAmountOverride, reason = 'location' } = {}) => {
    const amount = typeof requestedAmountOverride === 'number'
      ? requestedAmountOverride
      : this.state.requested_amount;

    if (
      typeof amount !== 'number' ||
      typeof this.state.lat !== 'number' ||
      typeof this.state.long !== 'number'
    ) {
      return;
    }

    this.notifyBusinessesLoaded([], { isSearching: true, requested_amount: amount, searchReason: reason });
  }

  maybeUpdateDashboardMap = () => {
    if (typeof this.props.onBusinessesLoaded !== 'function') {
      return;
    }

    const finalBody = this.buildShowAgentBody({ allowFallbackAmount: true });
    if (!finalBody) {
      this.resetDashboardMapQuery();
      return;
    }
    const queryKey = `${finalBody.zip}|${finalBody.amount}|${this.state.lat}|${this.state.long}`;
    if (this.lastDashboardMapQuery === queryKey) {
      return;
    }
    this.lastDashboardMapQuery = queryKey;
    this.fetchNearbyBusinesses(finalBody, { updateDashboardOnly: true });
  };

  render() {
    const { t } = this.props;
    const { address, suggestions, locationLoading } = this.state;

    return (
      <div className="address-input">
        <Form onSubmit={this.handleFormSubmit} className="address-input__form">
          <div className="address-input__row">
            <label htmlFor="address-input-amount" className="address-input__label">
              {t('enterAmount', { ns: 'amountAvailable' })}:
            </label>
            <input
              id="address-input-amount"
              placeholder={t('placeholderAmount', { ns: 'amountAvailable' })}
              type="number"
              step="1"
              pattern="[0-9]*"
              name="amount"
              min="5"
              max={this.state.escrow_amount}
              className="address-input__field"
              onChange={this.handleAmountChange}
              onKeyDown={(e) => {
                if (['e', 'E', '.', '+', '-'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          {this.state.amountError && (
            <p className="aa-error">{this.state.amountError}</p>
          )}
          <div className="address-input__row address-input__row--stacked">
            <div className="address-input__label-line">
              <label className="address-input__label">
                {t('enterLocation', { ns: 'amountAvailable' })}:
              </label>
              <button
                type="button"
                disabled={locationLoading}
                onClick={this.locateZip}
                className="aa-locate-btn aa-locate-btn--inline"
              >
                <img
                  src={"../images/location.png"}
                  alt=""
                  className="aa-locate-icon"
                />
                <span className="aa-locate-text">
                  {locationLoading
                    ? t('loadingCurrentLocation', { ns: 'amountAvailable' })
                    : t('useCurrentLocation', { ns: 'amountAvailable' })}
                </span>
              </button>
            </div>
            <div className="address-input__picker">
              <Select
                showSearch
                placeholder={t('searchPlaceholder', { ns: 'amountAvailable' })}
                optionFilterProp="children"
                onSelect={this.handleSelect}
                onSearch={this.handleSearch}
                onBlur={this.handleAddressBlur}
                filterOption={false}
                value={address || undefined}
                onChange={(val) => this.setState({ address: val })}
                size="middle"
                className="address-input__select"
                dropdownMatchSelectWidth={360}
              >
                {suggestions.map((s) => (
                  <Option key={s.place_id} value={s.description}>
                    {s.description}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          {/*!this.state.requested_amount && (
            <p className="address-input__hint">
              {t('enterAmountFirst', { ns: 'amountAvailable' })}
            </p>
          )*/}
          {this.state.addressError && (
            <p className="aa-error">{this.state.addressError}</p>
          )}
        </Form>
      </div>
    )
  }
}

const WrappedAddressInputForm = Form.create({ name: 'address_input_form' })(AddressInputInner);

const AddressInput = (props) => {
  return <WrappedAddressInputForm {...props} />;
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tokenAction,
      saveCashRequestDto,
    },
    dispatch
  );

const mapStateToProps = (state) => {
  return {
    token: state.token,
    profile: state.profile,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(
    withRecoil(
      withTranslation('amountAvailable')(AddressInput),
      [accessTokenState, merchantAddressState, merchantNameState, amountState]
    )
  )
);
